<script lang="ts">
	import Avatar from './Avatar.svelte'

	export let username: string
	export let size: string = 's'
</script>

<a
	href="/@{username.toLowerCase()}"
	class:s={size === 's'}
	class="group flex items-center gap-[6px] relative whitespace-nowrap overflow-ellipsis font-bold text-sm w-fit"
>
	<Avatar {size} {username} />
	<span class="group-hover:underline">{username}</span>
</a>

<style lang="postcss">
	.s {
		@apply font-normal;
	}
</style>
